import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isPaidPremium({
	edition,
	isInTrial,
	isInPredunning,
}: EditionAwarenessContextType): boolean {
	return edition === 'premium' && !isInTrial && !isInPredunning;
}
